import React from 'react'
import { Panel } from 'rsuite'

import { EMPTY_VALUE } from '../../../constants/constants'
import moment from 'moment'
import { DD_MM_YYYY_SLASH, REQUEST_DATE_FORMAT } from '../../../constants/date'

export default function ActivitieTimeViewWidget({ schema, header, items, newItems, ...props }) {
  return (
    <Panel
      style={props.style || { marginTop: 20 }}
      header={header || 'ช่วงเวลาที่จัดกิจกรรม'}
      collapsible //={props.collapsible}
      defaultExpanded //={props.defaultExpanded}
      bordered //={props.bordered}
    >
      <div style={{ marginTop: -10 }}>
        <Panel>
          {items?.map((e) => {
            return (
              <p>
                <span>{e.label || ''} เดือน : </span>{' '}
                <span>
                  <>{e.valueDef ? <b>{e.valueDef} </b> : <u>{EMPTY_VALUE}</u>}</>
                </span>
              </p>
            )
          })}

          {/* {newItems?.length > 0 && (
            <div style={{ marginTop: 10 }}>
              {schema.type.label} : <b>{newItems[0].type == '1' ? 'เดือน' : 'ช่วงเวลา'}</b>
            </div>
          )} */}

          {newItems?.map((e, index) => {
            return (
              <p>
                {e.type == '1' ? (
                  <>
                    <span>{e.label || ''} เดือน : </span>
                    <span>
                      <>{e.valueName ? <b>{e.valueName} </b> : <u>{EMPTY_VALUE}</u>}</>
                    </span>
                  </>
                ) : (
                  <>
                    <span style={{ marginRight: 10 }}>ช่วงที่ {index + 1}</span>
                    <span>
                      <>
                        {e.startDate || e.endDate ? (
                          <b>{`${
                            e.startDate
                              ? moment(e.startDate, REQUEST_DATE_FORMAT).format(DD_MM_YYYY_SLASH)
                              : ''
                          } - ${
                            e.endDate
                              ? moment(e.endDate, REQUEST_DATE_FORMAT).format(DD_MM_YYYY_SLASH)
                              : ''
                          }`}</b>
                        ) : (
                          <u>{EMPTY_VALUE}</u>
                        )}{' '}
                      </>
                    </span>
                  </>
                )}
              </p>
            )
          })}
        </Panel>
      </div>
    </Panel>
  )
}
